export function shareOnTwitter({ url, title }) {
  const top = window.innerHeight / 2;
  const left = window.innerWidth / 2 - 225;
  const position = `height=250,width=550,top=${top},left=${left}`;

  window.open(
    `http://twitter.com/share?url=${url}&text=${title}`,
    'twitter',
    `${position},toolbar=0,location=0,menubar=0,directories=0,scrollbars=0`
  );
}
